import { useTranslation } from 'next-i18next'

import { useAutomaticallyUpdateRadius } from '@/hooks/useAutomaticallyUpdateRadius'
import { TextLink } from '@/ui/atoms/text-link'
import { SystemMessage } from '@/ui/molecules/system-message'

export const AutoChangeRadiusLocationSystemMessage = () => {
  const { t } = useTranslation('common')

  const {
    handleCloseSystemMessage,
    shouldShowSystemMessage,
    switchRadiusToPreviousValue,
    autoUpdateRadiusValues,
  } = useAutomaticallyUpdateRadius()

  return (
    shouldShowSystemMessage &&
    autoUpdateRadiusValues && (
      <SystemMessage
        closeButtonLabel={t('modals.close.button.label')}
        description={
          <TextLink
            as="button"
            hasUnderline
            variant="secondary"
            onClick={() => switchRadiusToPreviousValue(autoUpdateRadiusValues.prevValue)}
          >
            {t(`system_messages.auto_change_location.description`, {
              value: autoUpdateRadiusValues.prevValue,
            })}
          </TextLink>
        }
        onClose={handleCloseSystemMessage}
        title={t(`system_messages.auto_change_location.title`, {
          value: autoUpdateRadiusValues.currValue,
        })}
        variation="tip"
      />
    )
  )
}
